var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"float-right"},[_c('I18n')],1),_vm._v(" "),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$te(("meta." + (this.$route.meta.id) + ".title"))
      ? _vm.$t(("meta." + (this.$route.meta.id) + ".title"))
      : _vm.$t('meta.title'))}}),_vm._v(" "),_c('hr',{staticClass:"trait",attrs:{"role":"presentation"}})])}
var staticRenderFns = []

export { render, staticRenderFns }